const APP_STORAGE_PREFIX = 'teslawithme:';

export function clearTeslaWithMeBrowserState(): void {
  clearStorageBucket(window.localStorage);
  clearStorageBucket(window.sessionStorage);
}

function clearStorageBucket(storage: Storage): void {
  const keysToRemove: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (key?.startsWith(APP_STORAGE_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => storage.removeItem(key));
}
